<template>
    <div id="header">
        <div class="container pl-0 pr-0">
            <div class="row p-0 m-0 mb-2">
                <div class="col-lg-2 d-none d-md-none d-sm-none d-xs-none d-lg-block pt-2">
                    <a href="/"><img class="w-50 logo" src="../../../assets/images/mus-logo_120.png" alt="Uigeverij MUS logo"></a>
                </div>
                <div class="col-lg-10 col-md-12 col-sm-12 col-12  pt-4 header-content">
                    <div class="row justify-content-end topper mb-2">
                        <div class=" col-md-2 d-none d-md-block d-lg-none"> <!-- ONLY DISPLAYS AT MEDIUM SCREENS-->
                            <a href="/"><img class="align-items-start w-50 logo" src="../../../assets/images/mus-logo_120.png" alt="Uigeverij MUS logo"></a>
                        </div>
                        <div class=" col-sm-4 d-none d-sm-block d-md-none"> <!-- ONLY DISPLAYS AT SMALL SCREENS-->
                            <a href="/"><img class="align-items-start w-25 logo" src="../../../assets/images/mus-logo_120.png" alt="Uigeverij MUS logo"></a>
                        </div>
                        <div class="col-3 d-block d-lg-none d-md-none d-sm-none"> <!-- ONLY DISPLAYS AT SMALL SCREENS-->
                            <a href="/"><img class="align-items-start w-25 logo" src="../../../assets/images/mus-logo_120.png" alt="Uigeverij MUS logo"></a>
                        </div>
                        <div class="col-md-4 col-lg-3 col-sm-4 col-6  text-center font-weight-normal text-muted contact-text">
                            
                        </div>
                        <div class="col-md-3 col-lg-2 col-sm-4 col-3 social-icon">
                            
                        </div>
                    </div>
                    <div class="row mt-3 bt-menu">
                        <div class="col-lg-7 col-md-7 col-sm-12 p-0">
                            <div class="btn-group search-mod col-12 p-0" role="group" aria-label="Button group with nested dropdown">
                                <input v-model="searchString" type="text" class="w-75 text-muted" placeholder="Zoeken" id="input" v-on:keyup.enter="search()">   
                                    <b-button-group>  
                                        <!-- <b-dropdown left text="Categorie" id="category">
                                        <b-dropdown-item v-for="(item, key) in searchcategories" @click="selectSearchCategory(item.id, item.name)" :key="'category_'+key">{{ item.name }}</b-dropdown-item>
                                        </b-dropdown> -->
                                          <b-button class="btn " id="searchBtn" @click="search()">
                                            <i class="fas fa-search"></i>
                                        </b-button>
                                    </b-button-group>
                            </div>
                        </div>
                        <div class="col-lg-5 col-md-5 col-sm-12">
                            <ul class="list-unstyled col-12 header-navs p-0">
                                <div class="row">
                                    <li v-if="searchlinks[0]" class="mr-5 d-inline"><a :href="searchlinks[0].url">{{ searchlinks[0].name }}</a></li>
                                    <li v-if="searchlinks[1]" class="mr-5 d-inline"><a :href="searchlinks[1].url">{{ searchlinks[1].name }}</a></li>
                                    <li v-if="searchlinks[2]" class="mr-5 d-inline text-right"><a :href="searchlinks[2].url"><b>{{ searchlinks[2].name }}</b></a></li>
                                
                                    <li v-if="searchlinks[3]" class="mr-5 d-inline"><a :href="searchlinks[3].url">{{ searchlinks[3].name }}</a></li>
                                    <li v-if="searchlinks[4]" class="mr-5 d-inline"><a :href="searchlinks[4].url">{{ searchlinks[4].name }}</a></li>
                                    <li v-if="searchlinks[5]" class="mr-5 d-inline text-right"><a :href="searchlinks[5].url"><b>{{ searchlinks[5].name }}</b></a></li>
                                </div>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'Header',
    props:{
        'searchcategories' : {
            type: Array
        },
        'fburl' : {
            type: String
        },
        'instagramurl' : {
            type: String
        },
        'searchlinks' : {
            type: Array
        }
    },
    data(){
        return{
            url:window.location.href,
            category : {
                id: 0,
                name: "Categorie",
            },
            searchString : '',
        }
    },
    methods:{
        selectSearchCategory : function(id, name){
            this.category.id = id; 
            this.category.name = name; 
        },
        search(){
            window.location.href = '/template/search?category_id='+this.category.id+'&search='+this.searchString;
        },
    }
}
</script>

<style scoped>
    .social-icon ul li i.fab{
        font-size: 35px;
        margin-right:5px;
    }
    #header .container{
        padding-right:0px !important;
        padding-left: 0px !important;
    }
    .logo{
        float:center;
        margin-top:10px;
    }
    .contact-text{
        font-size: 14px;
        font-weight: bold !important;
    }
    #input{
        padding: 7px 10px;
        /* font-size: 13px; */
    }
    
    #searchBtn{
        background: #010101;
        color: white;
        -webkit-transform:rotate(90deg);
        transform:rotate(90deg);
        border-radius: 0px;
    }
    .header-navs li a{
        color: black !important;
        font-weight: bold;
        font-size: 13px;
    }

    @media (max-width:992px){
        #header .container{
            padding-right:0px !important;
            padding-left: 0px !important;
            margin:0px auto !important;
            width: 90%;
        }
        .topper{
            justify-content: center !important;
        }
        .contact-text,.social-icon{
            padding-top: 20px !important;
        }
        .header-content{
            padding-top: 0px !important;
        }
    }



     @media (max-width:768px){
        #header .container{
            padding-right:0px !important;
            padding-left: 0px !important;
            margin:0px auto !important;
            max-width: 90%;
        }
        .topper{
            justify-content: center !important;
        }
        .contact-text,.social-icon{
            padding-top: 20px !important;
        }
        .logo{
            width: 40% !important;
        }
        .header-navs{
            margin-top:10px;
        }
    }


     @media (max-width:576px){
        #header .container{
            padding-right:0px !important;
            padding-left: 0px !important;
            margin:0px auto !important;
            max-width: 95%;
            width: 95% !important;
        }
        .topper{
            justify-content: center !important;
        }
        .contact-text,.social-icon{
            padding-top: 20px !important;
        }
        .social-icon li img{
            width: 45% !important;
        }
        .logo{
            width: 90% !important;
        }
        .header-navs{
            margin-top:10px;
        }
        .header-content{
            padding: 0px !important;
        }
        .bt-menu{
            padding: 0px 14px;
        }
        .search-mod{
            padding: 3px 0px 0px 0px !important;
        }
    }

</style>





// WEBPACK FOOTER //
// src/components/mus/layouts/header.vue